// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"fabdb12a","192":"7f6f7d27","220":"e9f3b16c","371":"e6a53dd0","413":"bbc5aacd","440":"29dccc37","581":"4f6ce7bd","636":"149f7572","847":"9f766e6d","988":"3a20efb2"}[chunkId] + ".chunk.js";
};